"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _username_input = _interopRequireDefault(require("../../ui/input/username_input"));
var c = _interopRequireWildcard(require("../index"));
var _index2 = require("../../store/index");
var l = _interopRequireWildcard(require("../../core/index"));
var _username = require("../username");
var _avatar = require("../../avatar");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var UsernamePane = exports.default = /*#__PURE__*/function (_React$Component) {
  function UsernamePane() {
    _classCallCheck(this, UsernamePane);
    return _callSuper(this, UsernamePane, arguments);
  }
  _inherits(UsernamePane, _React$Component);
  return _createClass(UsernamePane, [{
    key: "componentDidMount",
    value: function componentDidMount(e) {
      var _this$props = this.props,
        lock = _this$props.lock,
        validateFormat = _this$props.validateFormat,
        usernameStyle = _this$props.usernameStyle,
        strictValidation = _this$props.strictValidation;
      if (l.ui.avatar(lock) && c.username(lock)) {
        (0, _avatar.requestAvatar)(l.id(lock), c.username(lock));
      }
      (0, _index2.swap)(_index2.updateEntity, 'lock', l.id(lock), _username.setUsername, c.username(lock), usernameStyle, validateFormat, strictValidation);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      var _this$props2 = this.props,
        lock = _this$props2.lock,
        validateFormat = _this$props2.validateFormat,
        usernameStyle = _this$props2.usernameStyle,
        strictValidation = _this$props2.strictValidation;
      if (l.ui.avatar(lock)) {
        (0, _avatar.debouncedRequestAvatar)(l.id(lock), e.target.value);
      }
      (0, _index2.swap)(_index2.updateEntity, 'lock', l.id(lock), _username.setUsername, e.target.value, usernameStyle, validateFormat, strictValidation);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        i18n = _this$props3.i18n,
        lock = _this$props3.lock,
        placeholder = _this$props3.placeholder,
        validateFormat = _this$props3.validateFormat;
      var allowAutocomplete = l.ui.allowAutocomplete(lock);
      var value = c.getFieldValue(lock, 'username');
      var usernameValidation = validateFormat ? (0, _username.getUsernameValidation)(lock) : {};

      // TODO: invalidErrorHint and blankErrorHint are deprecated.
      // They are kept for backwards compatibility in the code for the customers overwriting
      // them with languageDictionary. They can be removed in the next major release.
      var invalidHintKey = function invalidHintKey(str) {
        if (!str) {
          return i18n.str('blankErrorHint') ? 'blankErrorHint' : 'blankUsernameErrorHint';
        }
        if ((0, _username.usernameLooksLikeEmail)(str) || !validateFormat) return i18n.str('invalidErrorHint') ? 'invalidErrorHint' : 'invalidUsernameErrorHint';
        return 'usernameFormatErrorHint';
      };
      var invalidHint = function invalidHint(str) {
        var hintKey = invalidHintKey(str);

        // only show format info in the error if it should validate the format and
        // if there is any format restrictions for the connection
        if ('usernameFormatErrorHint' === hintKey && validateFormat && usernameValidation != null) {
          return i18n.str(hintKey, usernameValidation.min, usernameValidation.max);
        }
        return i18n.str(hintKey);
      };
      return /*#__PURE__*/_react.default.createElement(_username_input.default, {
        value: value,
        invalidHint: invalidHint(value),
        isValid: !c.isFieldVisiblyInvalid(lock, 'username'),
        onChange: this.handleChange.bind(this),
        placeholder: placeholder,
        autoComplete: allowAutocomplete,
        disabled: l.submitting(lock)
      });
    }
  }]);
}(_react.default.Component);
UsernamePane.propTypes = {
  i18n: _propTypes.default.object.isRequired,
  lock: _propTypes.default.object.isRequired,
  placeholder: _propTypes.default.string.isRequired,
  validateFormat: _propTypes.default.bool.isRequired,
  usernameStyle: _propTypes.default.oneOf(['any', 'email', 'username']),
  strictValidation: _propTypes.default.bool.isRequired
};
UsernamePane.defaultProps = {
  validateFormat: false,
  usernameStyle: 'username'
};
